import styled from 'styled-components';
import { rem } from 'polished';
import { compareTableColumns } from '../index.styles';

export const CTARow = styled.div`
  ${compareTableColumns}
  grid-column: 1 / -1;
  align-items: start;
`;

export const CTAPlaceholder = styled.div`
  grid-column: 1;
  min-height: 0;

  @media ${({ theme }) => theme.media.smallDesktopMin} {
    display: block;
  }
`;

export const CTACell = styled.div`
  display: flex;
  justify-content: center;
  min-width: 0;
`;

export const FactSheetRow = styled.div`
  ${compareTableColumns}
  grid-column: 1 / -1;
  align-items: center;
  padding-top: ${rem(20)};
`;

export const FactSheetPlaceholder = styled.div`
  grid-column: 1;
  min-height: 0;

  @media ${({ theme }) => theme.media.smallDesktopMin} {
    display: block;
  }
`;

export const FactSheetCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 0;

  padding: ${rem(6)} 0;
`;